import React from "react";

export interface IconCheckMarkProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconCheckMark: React.FC<IconCheckMarkProps> = ({
  width = 37,
  height = 29,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 37 29"
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    {...props}
  >
    <path d="M12.5668 27.7545L0.54183 15.7295C-0.18061 15.0071-0.18061 13.8357 0.54183 13.1132L3.15806 10.4969C3.8805 9.77439 5.05193 9.77439 5.77437 10.4969L13.875 18.5975L31.2256 1.24691C31.948 0.524468 33.1195 0.524468 33.8419 1.24691L36.4581 3.86321C37.1806 4.58565 37.1806 5.75701 36.4581 6.47952L15.1831 27.7546C14.4606 28.477 13.2893 28.477 12.5668 27.7545Z" />
  </svg>
);
